import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@billda/design-system';
import { useRestoreFile } from '../../hooks/useRecycleBin';

interface RestoreCollisionDialogProps {
  open: boolean;
  onClose: () => void;
  conflictInfo: {
    conflictingFileId: string;
    conflictingFileName: string;
    targetFolderId: string | null;
  };
  fileId: string;
  fileName: string;
  siteId?: number;
}

export function RestoreCollisionDialog({
  open,
  onClose,
  conflictInfo,
  fileId,
  fileName,
  siteId,
}: RestoreCollisionDialogProps) {
  const restoreFile = useRestoreFile(siteId);

  const handleRename = () => {
    const ext = fileName.lastIndexOf('.');
    const baseName = ext > 0 ? fileName.substring(0, ext) : fileName;
    const extension = ext > 0 ? fileName.substring(ext) : '';
    const newName = `${baseName} (1)${extension}`;

    restoreFile.mutate({ fileId, body: { newName } }, { onSuccess: onClose });
  };

  const handleReplace = () => {
    restoreFile.mutate(
      {
        fileId,
        body: { replaceFileId: conflictInfo.conflictingFileId },
      },
      { onSuccess: onClose }
    );
  };

  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onClose()}>
      <DialogContent data-testid="restore-collision-dialog">
        <DialogHeader>File already exists</DialogHeader>
        <DialogBody>
          A file named &quot;{conflictInfo.conflictingFileName}&quot; already
          exists in the target folder.
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="ghost"
            onClick={handleRename}
            disabled={restoreFile.isPending}
            data-testid="rename-button"
          >
            Rename
          </Button>
          <Button
            variant="neutral"
            onClick={handleReplace}
            disabled={restoreFile.isPending}
            data-testid="replace-button"
          >
            Replace
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
